module.exports = __webpack_public_path__ + "img/Group 27487.3504f249.svg";